import SvgIcon from "@mui/material/SvgIcon";

export const OffersIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.0774 21.5024L3.55408 11.7124V13.7124C3.55408 14.2424 3.75836 14.7524 4.12801 15.1224L11.7058 22.9124C12.4646 23.6924 13.7 23.6924 14.4587 22.9124L20.4996 16.7024C21.2584 15.9224 21.2584 14.6524 20.4996 13.8724L13.0774 21.5024Z"
        fill="white"
      />
      <path
        d="M11.7058 17.9124C12.0852 18.3024 12.5813 18.5024 13.0774 18.5024C13.5735 18.5024 14.0696 18.3024 14.449 17.9124L20.4899 11.7024C21.2486 10.9224 21.2486 9.65244 20.4899 8.87244L12.9121 1.08244C12.5521 0.712441 12.056 0.502441 11.5405 0.502441H5.4996C4.42956 0.502441 3.55408 1.40244 3.55408 2.50244V8.71244C3.55408 9.24244 3.75836 9.75244 4.12801 10.1224L11.7058 17.9124ZM5.4996 2.50244H11.5405L19.1183 10.2924L13.0774 16.5024L5.4996 8.71244V2.50244Z"
        fill="white"
      />
      <path
        d="M7.68832 6.00244C8.35987 6.00244 8.90427 5.4428 8.90427 4.75244C8.90427 4.06209 8.35987 3.50244 7.68832 3.50244C7.01677 3.50244 6.47236 4.06209 6.47236 4.75244C6.47236 5.4428 7.01677 6.00244 7.68832 6.00244Z"
        fill="white"
      />
    </svg>
  </SvgIcon>
);
